import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

/**
 * @Author: 韩祺涛
 * @Date: 2022-11-28
 * @Project: 杭氧
 */
// 获取使用部门树
export function getDeptTreeList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/companyTree',
    // url: '/data/assetDept.json',
    method: 'GET',
    params: parameter
  })
}
// 获取使用部门树,搜索条件中使用
export function getDeptTreeListInSearch (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/tree',
    // url: '/data/assetDept.json',
    method: 'GET',
    params: parameter
  })
}
// 获取资产分类树
export function getAssetTypeTreeList (parameter) {
  return axios({
    // url: sysInfo.apiRemote + '/dict/query',
    url: sysInfo.apiRemote + '/assetType/all', // 最新接口，现场用
    method: 'GET',
    params: parameter
  })
}
// 获取资产分类树
export function getAssetTypeTreeRole(parameter) {
  return axios({
    // url: sysInfo.apiRemote + '/dict/query',
    url: sysInfo.apiRemote + '/role/assetType/role', // 最新接口，现场用
    method: 'GET',
    params: parameter
  })
}
// 获取资产状态
export function assetTypeList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getZCZT',
    // url: '/data/getZCZT.json',
    method: 'GET',
    params: parameter
  })
}
// 获取增加方式，使用状态下拉数据
export function getSelectDataList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getZCDICT',
    // url: '/data/getZCDICT.json',
    method: 'GET',
    params: parameter
  })
}
// 获取归口部门下拉数据
export function getfocalDepartmentsList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevantsByAuth',
    method: 'GET',
    params: parameter
  })
}
// 获取使用部门下拉数据
export function getTreeByRoleUsedeptList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/treeByRoleUsedept',
    method: 'GET',
    params: parameter
  })
}
// 获取资产表格
export function getAssetTableData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/list',
    // url: '/data/assetList.json',
    method: 'GET',
    params: parameter
  })
}
// 资产统计
export function getAssetTableTotal (parameter) {
  return axios({
     // url: '/data/assetStatistics.json',
    url: sysInfo.apiRemote + '/asset/statistics',
    method: 'GET',
    params: parameter
  })
}
// 获取资产详情信息
export function getAssetDetail (parameter) {
  return axios({
    // url: '/data/assetDetail.json',
    url: sysInfo.apiRemote + '/asset/detail',
    method: 'GET',
    params: parameter
  })
}
// 获取资产价值基本信息
export function getAssetValueDetail (parameter) {
  return axios({
    // url: '/data/assetValueDetail.json',
    url: sysInfo.apiRemote + '/asset/detail',
    method: 'GET',
    params: parameter
  })
}
// 获取资产价值折旧参数
export function getAssetDepreciationParameters (parameter) {
  return axios({
    // url: '/data/assetDepreciationParameters.json',
    url: sysInfo.apiRemote + '/asset/depreciation/parameters',
    method: 'GET',
    params: parameter
  })
}
// 获取本年度折旧执行情况
export function getAssetCurrDepreciate (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getAssetCurrDepreciate',
    method: 'GET',
    params: parameter
  })
}
// 获取历史年度折旧
export function getAssetHistrDepreciate (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getAssetHistrDepreciate',
    method: 'GET',
    params: parameter
  })
}
// 资产价值 - 资产价值变动相关会计凭证
export function getAssetAccounting (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getAccountingDocuments',
    method: 'GET',
    params: parameter
  })
}
// 获取在建资产工程信息
export function getAssetEngineeringDetail (parameter) {
  return axios({
    // url: '/data/assetEngineeringDetail.json',
    url: sysInfo.apiRemote + '/asset/ebeln',
    method: 'GET',
    params: parameter
  })
}

// 导出
export function getAssetExport (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/export',
    responseType: 'blob',
    // timeout: 5 * 60 * 1000,
    method: 'GET',
    params: parameter
  })
}
// 获取字典
export function getTreeList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict',
    method: 'GET',
    params: parameter
  })
}
// 同步
export function getSyncAsset (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sync/asset',
    method: 'POST',
    data: parameter
  })
}
// 资产图表
export function getChart (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getChart',
    method: 'GET',
    params: parameter
  })
}

// 资产图表右侧排序
export function getAssetTypeBySort (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getAssetTypeBySort',
    method: 'GET',
    params: parameter
  })
}
// 资产统计条数
export function getAssetTotal (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getAssetTotal',
    method: 'GET',
    params: parameter
  })
}

// 折旧预测总额
export function getAssetForecast (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getAssetForecast',
    method: 'GET',
    params: parameter
  })
}

// 根据资产编码及所属公司获取设备信息
export function getListByAssetNumber (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/getListByAssetNumber',
    method: 'GET',
    params: parameter
  })
}
